<script>
import ModalOverlay from '@/components/modal/ModalOverlay';
import Button from '@/components/Button';
import { mapState, mapActions } from 'vuex';
import { readError, isFunction } from '@/scripts/utils';

export default {
  name: 'ModalError',
  components: {
    Button,
    ModalOverlay,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(['error', 'errorCloseCallback']),
    errorText() {
      const { error } = this;
      const result = readError(error);

      return result;
    },
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions({
      setError: 'setError',
      setErrorCloseCallback: 'setErrorCloseCallback',
    }),
    action() {
      if (isFunction(this.errorCloseCallback)) {
        this.errorCloseCallback();
        this.setErrorCloseCallback(null);
      }

      this.close();
    },
    close() {
      this.setError(null);
    },
  },
};
</script>

<template>
  <div>
    <ModalOverlay>
      <div class="modal__dialog">
        <div class="modal__content">
          <div class="modal__top">
            <div class="modal__title">
              Error !
            </div>
            <div class="modal__close" @click="close">
              <img :src="require('@/assets/svg/close.svg')" />
            </div>
          </div>
          <div class="modal__middle">
            <!--  -->
            <div class="modal__text">
              {{ errorText }}
            </div>
          </div>
          <div class="modal__bottom">
            <!--  -->
            <Button
              class="negative m-290"
              :autofocus="true"
              @click="action"
              tabindex="0"
            >
              Ok
            </Button>
          </div>
        </div>
      </div>
    </ModalOverlay>
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.modal {
  &__dialog {
    padding: 87px 20px 40px;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
  }

  &__content {
    max-width: 570px;
    max-height: 100%;
    border-radius: 36px;
    background-color: #101112;
    border: solid 1px rgba(249, 88, 98, 0.2);
    padding: 0 0 40px;
    display: flex;
    flex-direction: column;
    width: 100%;
    color: #ffffff;
  }

  &__top {
    text-align: center;
    position: relative;
    padding: 40px 0 0;
    flex-shrink: 0;
  }

  &__title {
    font-family: Poppins-Regular;
    font-size: 21px;
    line-height: 29px;
    margin-bottom: 14px;
    color: #f95862;
  }

  &__text {
    font-family: Poppins-Light;
    font-size: 14px;
    line-height: 1.86;
    max-width: 420px;
    margin: 0 auto;
    width: 100%;
  }

  &__middle {
    flex-grow: 1;
    text-align: center;
  }

  &__bottom {
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    margin-top: 50px;
  }

  &__close {
    position: absolute;
    right: 25px;
    top: 25px;
    width: 12px;
    height: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    cursor: pointer;

    img {
      display: flex;
      width: 100%;
      height: 100%;
    }

    &:hover {
      opacity: 0.5;
    }
  }
}

@media (max-width: $mobile) {
  .modal {
    &__dialog {
      padding: 0;
    }

    &__content {
      max-width: none;
      height: 100%;
      border: 0 !important;
      border-radius: 0;
      overflow-y: auto;
      -webkit-overflow-scrolling: tuch;
    }

    &__top {
      padding-top: 100px;
    }

    &__title {
      padding: 0 15px;
    }

    &__middle {
      padding: 0 15px;
    }

    &__bottom {
      padding: 0 15px;
    }
  }
}
</style>
